import { ReactNode } from "react";

import Modal from "@whoppah/ui/Modal2";

type ReservationDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
  /** Buttons; stacked full width at 375 px, side by side from `sm`. */
  actions: ReactNode;
};

/**
 * WHO-5947. The one modal shape for reservations (request, release, locked
 * actions). Built on the same `Modal` as the bid and delete modals (F5): it
 * sits above the header, dims the whole page and has the close X. No form
 * fields ever: the request carries no free text (decision 14).
 */
export const ReservationDialog = ({
  open,
  onOpenChange,
  title,
  children,
  actions,
}: ReservationDialogProps) => (
  <Modal
    open={open}
    title={title}
    className="md:max-w-[480px]"
    onClose={() => onOpenChange(false)}
  >
    <div
      className="flex flex-col gap-3 font-body text-sm text-grey-800 md:text-base"
      data-testid="reservation-dialog-body"
    >
      {children}
    </div>
    <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      {actions}
    </div>
  </Modal>
);
